<template>
    <v-card class="rounded-xl mt-0 border-primary-card" :class="$vuetify.display.smAndUp ? 'px-7 py-4' : 'pa-3'">
        <div v-for="(student, studentIndex) in getStudents" :key="studentIndex">
            <summary-module-card
                v-for="(session, preparationId) in student.preparations"
                :key="preparationId"
                class="my-3"
                :session="session"
                :sessionPrice="getItemPrice(session, student.preparations)"
                :studentIndex="studentIndex"
                :childName="`${student.firstname} ${student.lastname}`"
            />
        </div>
        <v-card-title class="mb-2">
            <div class="d-flex flex-column align-start">
                <div class="font-weight-bold title">
                    Total : <span v-if="getDiscountCode" class="text-decoration-line-through">{{ totalPrice }} €</span>
                    <span v-else>{{ totalPrice }} €</span>
                    <span v-if="getDiscountCode">&nbsp;{{ totalPriceWithDiscount }} €</span>
                </div>
                <div v-if="getDiscountCode" class="summary-discount">
                    La réduction de {{ getDiscountCodeValue }}% ({{ priceWithDiscount }}&nbsp;€) sera appliquée sur votre
                    facture
                </div>
            </div>
        </v-card-title>
        <v-form ref="discountForm" validate-on="submit lazy" @submit.prevent="addDiscountCode">
            <v-row>
                <v-col cols="12" md="6" class="pb-0">
                    <v-text-field v-model="discountCode" :error-messages="errorMessageDiscountForm" label="Code promo"
                                  density="compact" :rules="rules"></v-text-field>
                </v-col>
                <v-col v-if="getDiscountCode" cols="12" class="pb-0" align="start">
                    <v-chip closable @click:close="clearDiscountCode">
                        {{ getDiscountCode }}
                    </v-chip>
                </v-col>
                <v-col cols="12" align="start">
                    <v-btn type="submit" color="primary" class="font-weight-bold">
                        Ajouter ce code
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </v-card>
</template>

<script>

import {mapGetters} from 'vuex';

import moment from 'moment';

import SummaryModuleCard from '@/components/summary/SummaryModuleCard.vue';

export default {

    components: {
        SummaryModuleCard
    },

    data() {
        return {
            rules: [
                value => {
                    if (value) return true
                    return 'Merci de renseigner un code promo'
                },
            ],
            errorMessageDiscountForm: null,
            discountCode: null,
        }
    },

    computed: {

        ...mapGetters('payload', ['getPayload', 'getStudents']),
        ...mapGetters('discount', ['getDiscountCode', 'getDiscountCodeValue']),


        totalPrice() {
            let price = 0;
            Object.values(this.getStudents).forEach(student => {
                if (student.preparations) {
                    Object.values(student.preparations).forEach(session => {
                        price += parseInt(this.getItemPrice(session, student.preparations));
                    });
                }
            });

            return price;
        },

        totalPriceWithDiscount() {
            let price = 0;
            Object.values(this.getStudents).forEach(student => {
                if (student.preparations) {
                    Object.values(student.preparations).forEach(session => {
                        price += parseInt(this.getItemPrice(session, student.preparations));
                    });
                }
            });

            // Calculate discount
            if (this.getDiscountCodeValue && price > 0) {
                const percentageDiscount = this.getDiscountCodeValue / 100;
                price = price * (1 - percentageDiscount);
            }

            return price.toFixed(2);
        },

        priceWithDiscount() {
            return parseFloat(this.totalPriceWithDiscount - this.totalPrice).toFixed(2);
        }
    },

    methods: {

        getItemPrice(session, studentSessions) {
            const getCurrentPrice = {};
            session.prices.forEach((priceItem) => {
                const startDate = moment(priceItem.start_date).startOf('day');
                const endDate = moment(priceItem.end_date).startOf('day');
                const currentDate = moment().startOf('day');
                const checkDate = currentDate.isBetween(startDate, endDate, null, '[]');

                if (priceItem.end_date && checkDate) {
                    getCurrentPrice[priceItem.type] = parseInt(priceItem.amount_ttc);
                } else if (!priceItem.end_date && (startDate <= currentDate)) {
                    getCurrentPrice[priceItem.type] = parseInt(priceItem.amount_ttc);
                }
            });

            if ('AUTO1' in getCurrentPrice) {
                return getCurrentPrice['AUTO1'];
            }

            const numberItems = Object.values(studentSessions).filter(element => {
                if (element.product_type_id !== 2900012 &&
                    element.start_date === session.start_date &&
                    element.location && session.location &&
                    element.location.address === session.location.address) {
                    return element;
                }
            }).length;

            if (numberItems < 2) {
                return '1MAT' in getCurrentPrice ? getCurrentPrice['1MAT'] : 0;
            } else if (numberItems === 2) {
                return '2MAT' in getCurrentPrice ? getCurrentPrice['2MAT'] : 0;
            } else if (numberItems > 2) {
                if ('3MAT' in getCurrentPrice) {
                    return getCurrentPrice['3MAT'];
                } else if ('2MAT' in getCurrentPrice) {
                    return getCurrentPrice['2MAT'];
                } else {
                    return 0;
                }
            }

            return 0;
        },

        async addDiscountCode() {
            // Reset error message
            this.errorMessageDiscountForm = null;

            const {valid} = await this.$refs.discountForm.validate()

            if (valid) {
                try {
                    const response = await this.$store.dispatch('discount/validateDiscount', this.discountCode);

                    // If the response does not contain data, we exit the function
                    if (!response?.data) {
                        return;
                    }

                    const data = response.data;

                    if (data) {

                        const priceDiscount = parseInt(data.amount) / 100 * this.totalPrice;

                        if (priceDiscount > 100) {
                            this.errorMessageDiscountForm = 'Le montant de la remise dépasse le seuil maximal et doit être validé par un conseiller. Vous pouvez confirmer votre inscription et nous contacter directement au 01 42 05 41 36.';
                            return;
                        }

                        await this.$store.dispatch('discount/saveDiscountCode', this.discountCode);
                        await this.$store.dispatch('discount/saveDiscountCodeValue', parseInt(data.amount));
                    }

                    await this.$refs.discountForm.reset()
                } catch (error) {
                    this.errorMessageDiscountForm = error;
                }
            }
        },

        async clearDiscountCode() {
            await this.$store.dispatch('discount/clearAllDiscountData');
        }
    },
}

</script>


<style scoped>

.student {
    font-size: 20px;
}

.border-primary-card {
    border: 1px solid #06113a;
}

.summary-discount {
    font-size: 14px;
    font-weight: 600;
    color: #6B6C80;
    white-space: break-spaces;
    text-align: left;
}

</style>